export const TAG_LINK_GROUP_LABEL = 'tag_link_group.header_label';